import {FilterList} from '@mui/icons-material';
import {COLORS, SIZES, Typography} from '@fupa/fupa-uikit';
import {FilterMenu} from 'app/components/floatingAction/FilterMenu';
import React, {useState} from 'react';
import styled from 'styled-components';

const FilterWrapper = styled.div`
  cursor: pointer;
  display: table-cell;
  min-width: ${SIZES['42']};
  width: ${SIZES['42']};
  text-align: center;
  vertical-align: middle;

  & div:first-child {
    height: 2.5rem;
  }
`;

const StyledFilterList = styled(FilterList)`
  color: ${COLORS.darkGrey};
  font-size: ${SIZES['24']};
  vertical-align: 'middle';
`;

const FilterLabel = styled(Typography)`
  vertical-align: text-top;
  line-height: 0.75;
`;

const FilterActionBtn = ({filterValues, filterLabels, categories, regex}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleFilter = e => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const transformOrigin = {
    vertical: 'top',
    horizontal: 'right',
  };

  const anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
  };

  return (
    <>
      <FilterWrapper onClick={handleFilter}>
        <div>
          <StyledFilterList />
          <FilterLabel variant='caption1'>{filterLabels[categories] || filterLabels['default']}</FilterLabel>
        </div>
      </FilterWrapper>
      <FilterMenu
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        filter={filterValues}
        regex={regex}
        anchorEl={anchorEl}
        open={open}
        onCallback={handleClose}
      />
    </>
  );
};

export {FilterActionBtn};
